import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Chips allow users to enter information, make selections, filter content, or trigger actions.`}</p>
    <p>{`While buttons are expected to appear consistently and with familiar calls to action, chips should appear dynamically as a group of multiple interactive elements.`}</p>
    <div {...{
      "className": "line",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-one",
        "align": "center"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/android-1.png",
            "width": 250,
            "height": 250,
            "align": "center",
            "resize-mode": "contain",
            "alt": "chips usage"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <div className="divi" />
    <h2>{`Usage`}</h2>
    <p>{`Use this tag `}<inlineCode parentName="p">{`LgnPrimary{Size}ChipContainer`}</inlineCode>{`to implement Legion Chips.`}</p>
    <h2>{`Variants`}</h2>
    <h3><strong parentName="h3">{`Size`}</strong></h3>
    <p>{`Legion have two size variants of chips.`}</p>
    <h4>{`1. Small Variants`}</h4>
    <div {...{
      "className": "line",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-one",
        "align": "center"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/android-3.png",
            "width": 250,
            "height": 250,
            "align": "center",
            "resize-mode": "contain"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <p>{`The following is usage to implement `}<strong parentName="p">{`Small Size`}</strong>{` variants`}</p>
    <h4>{`Static in Xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml",
        "metastring": "title=\"layout_sample.xml\"",
        "title": "\"layout_sample.xml\""
      }}>{`<com.telkom.legion.component.chips.small.LgnPrimarySmallChipContainer
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Stacked Chip Filter Type"
    app:chipType="FILTER_TYPE" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnPrimarySmallChipContainer(requiredContext()).apply {
              //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <br />
    <h4>{`2. Large variants`}</h4>
    <div {...{
      "className": "line",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-one",
        "align": "center"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/android-2.png",
            "width": 250,
            "height": 250,
            "align": "center",
            "resize-mode": "contain"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <p>{`The following is usage to implement `}<strong parentName="p">{`Large Size`}</strong>{` variants`}</p>
    <h4>{`Static in Xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml",
        "metastring": "title=\"layout_sample.xml\"",
        "title": "\"layout_sample.xml\""
      }}>{`<com.telkom.legion.component.chips.large.LgnPrimaryLargeChipContainer
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Stacked Chip Filter Type"
    app:chipType="FILTER_TYPE" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnPrimaryLargeChipContainer(requiredContext()).apply {
              //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <br />
    <br />
    <h3><strong parentName="h3">{`Style`}</strong></h3>
    <p>{`Legion have two style variants of chips.`}</p>
    <h4>{`1. `}<strong parentName="h4">{`Default Type`}</strong></h4>
    <div {...{
      "className": "line",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-one",
        "align": "center"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/android-4.png",
            "width": 250,
            "height": 250,
            "align": "center",
            "resize-mode": "contain"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <p>{`To implement Default style , you can customize from the properties. `}<inlineCode parentName="p">{`app:chipType="DEFAULT_TYPE"`}</inlineCode></p>
    <h4>{`Static in Xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml",
        "metastring": "title=\"layout_sample.xml\"",
        "title": "\"layout_sample.xml\""
      }}>{`<com.telkom.legion.component.chips.small.LgnPrimarySmallChipContainer
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Stacked Chip Filter Type"
    app:chipType="DEFAULT_TYPE" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnPrimarySmallChipContainer(requiredContext()).apply {
            chipType = ChipsType.DEFAULT_TYPE
              //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <br />
    <br />
    <h4>{`2. `}<strong parentName="h4">{`Filter Type`}</strong></h4>
    <div {...{
      "className": "line",
      "style": {
        "backgroundColor": "white"
      }
    }}>{`
  `}<div parentName="div" {...{
        "className": "item-one",
        "align": "center"
      }}>{`
    `}<div parentName="div" {...{
          "style": {
            "padding": "7px 0"
          }
        }}>{`
      `}<img parentName="div" {...{
            "src": "https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/chips/android-5.png",
            "width": 250,
            "height": 250,
            "align": "center",
            "resize-mode": "contain"
          }}></img>{`
    `}</div>{`
  `}</div>
    </div>
    <p>{`To implement Filter style , you can customize from the properties. `}<inlineCode parentName="p">{`app:chipType="FILTER_TYPE"`}</inlineCode></p>
    <h4>{`Static in Xml`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-xml",
        "metastring": "title=\"layout_sample.xml\"",
        "title": "\"layout_sample.xml\""
      }}>{`<com.telkom.legion.component.chips.small.LgnPrimarySmallChipContainer
    android:layout_width="match_parent"
    android:layout_height="wrap_content"
    android:hint="Stacked Chip Filter Type"
    app:chipType="FILTER_TYPE" />
`}</code></pre>
    <h4>{`Dynamic using Kotlin`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "title=\"SampleFragment.kt\"",
        "title": "\"SampleFragment.kt\""
      }}>{`...
with(binding) {
    containerBase.addView( //ViewGroup for Dynamic Layout
        LgnPrimarySmallChipContainer(requiredContext()).apply {
            chipType = ChipsType.FILTER_TYPE
              //Your View's customization here
        },
        LinearLayout.LayoutParams( //For example we use viewgroup LinearLayout
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
    )
}
...
`}</code></pre>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{`) :`}</strong>{` Dynamic using Kotlin mean if you using Dynamic Layout or Declarative UI using kotlin`}</p>
    </InlineNotification>
    <div className="divi" />
    <h2>{`Attributes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Xml Attrs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Related method(s)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To get or set selection value on Filter Type directly`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:hint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`hint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set label value directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Enable Status `}<strong parentName="td">{`[WIP]`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set enable or disable chips directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Required Status`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isRequired`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set required status on text area directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional Status`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:isOptional`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isOptional`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set optional status on text area directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Helper text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:helperText`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`helper`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set helper text directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Chip Type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:chipType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`chipType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set chip type directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Single Line`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:isSingleLine`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isSingleLine`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set chips single line directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Show Close Icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:closeIconVisible`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`closeIconVisible`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set show close icon on chips directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Single Selection `}<strong parentName="td">{`[BETA]`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:isSingleSelection`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`isSingleSelection`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set chips single selection directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Background Color `}<strong parentName="td">{`[BETA]`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:chipBackgroundColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`chipBackgroundColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set chips background color directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Stroke Color `}<strong parentName="td">{`[BETA]`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`app:chipStrokeColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`chipStrokeColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set chips stroke color directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Text Color `}<strong parentName="td">{`[BETA]`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`android:textColor`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`textColors`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To set chips text color directly via xml`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add Chips`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`addAll(List<String>)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To add chips programaticaly`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add Listener`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`setListener { text -> }`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To add listener on chips programaticaly`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add Close Listener`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`N/A`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`setOnCloseIconClickListener { text -> }`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`To add close listener on chips programaticaly`}</td>
        </tr>
      </tbody>
    </table>
    <InlineNotification kind="info" mdxType="InlineNotification">
      <p><strong parentName="p">{`*`}{` BETA :`}</strong>{` Attribute mean there is a possibility that it does not work as expected and there is a possibility of bugs`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      